import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import frCommon from './locales/fr/common.json';
import frAuth from './locales/fr/auth.json';
import frDashboard from './locales/fr/dashboard.json';
import frOperations from './locales/fr/operations.json';
import frSettings from './locales/fr/settings.json';
import frProfile from './locales/fr/profile.json';
import frAdmin from './locales/fr/admin.json';
import frArchives from './locales/fr/archives.json';
import frLanding from './locales/fr/landing.json';
import frLegal from './locales/fr/legal.json';
import frFeatures from './locales/fr/features.json';
import frCategories from './locales/fr/categories.json';
import frTutorial from './locales/fr/tutorial.json';
import frSubscription from './locales/fr/subscription.json';
import frHelp from './locales/fr/help.json';
import frSearch from './locales/fr/search.json';

import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enOperations from './locales/en/operations.json';
import enSettings from './locales/en/settings.json';
import enProfile from './locales/en/profile.json';
import enAdmin from './locales/en/admin.json';
import enArchives from './locales/en/archives.json';
import enLanding from './locales/en/landing.json';
import enLegal from './locales/en/legal.json';
import enFeatures from './locales/en/features.json';
import enCategories from './locales/en/categories.json';
import enTutorial from './locales/en/tutorial.json';
import enSubscription from './locales/en/subscription.json';
import enHelp from './locales/en/help.json';
import enSearch from './locales/en/search.json';

const resources = {
  fr: {
    common: frCommon,
    auth: frAuth,
    dashboard: frDashboard,
    operations: frOperations,
    settings: frSettings,
    profile: frProfile,
    admin: frAdmin,
    archives: frArchives,
    landing: frLanding,
    legal: frLegal,
    features: frFeatures,
    categories: frCategories,
    tutorial: frTutorial,
    subscription: frSubscription,
    help: frHelp,
    search: frSearch,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    operations: enOperations,
    settings: enSettings,
    profile: enProfile,
    admin: enAdmin,
    archives: enArchives,
    landing: enLanding,
    legal: enLegal,
    features: enFeatures,
    categories: enCategories,
    tutorial: enTutorial,
    subscription: enSubscription,
    help: enHelp,
    search: enSearch,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    // Les ressources et le reste du code raisonnent en 'fr' / 'en', jamais en
    // locale régionale. Ces options gardent i18n.language sur cette forme :
    // sans elles il vaut 'fr-FR' (ce que renvoie le navigateur), les traductions
    // passent quand même par le repli sur 'fr', mais les quelque quinze
    // `language === 'fr'` du code échouent et basculent le formatage des
    // montants et des dates en en-US.
    //
    // C'est convertDetectedLanguage qui fait le travail : load et supportedLngs
    // ne corrigent que la résolution des ressources (i18n.languages), pas
    // i18n.language lui-même.
    supportedLngs: ['fr', 'en'],
    load: 'languageOnly',
    defaultNS: 'common',
    ns: ['common', 'auth', 'dashboard', 'operations', 'settings', 'profile', 'admin', 'archives', 'landing', 'legal', 'features', 'categories', 'tutorial', 'subscription', 'help', 'search'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'splinity-language',
      caches: ['localStorage'],
      // 'fr-FR' → 'fr' (et neutralise une valeur régionale déjà en localStorage)
      convertDetectedLanguage: (lng: string) => lng.split('-')[0],
    },
  });

export default i18n;
